var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cat"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-card"},[_c('div',{staticClass:"vx-card__body card-body"},[_c('div',{staticClass:"vx-row"})])])
}]

export { render, staticRenderFns }